<template>
  <v-container fluid>
    <v-card>
      <v-container fluid>
        <v-form :disabled="buscando" @submit.prevent="buscarItensVinculadosComFiltro(true)">
          <v-row>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemCliente.descricao"
                label="Descrição"
                :loading="buscando"
              />
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemCliente.codigoBarra"
                label="Código de Barras"
                :loading="buscando"
                type="number"
              />
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemCliente.ncm"
                label="NCM"
                :loading="buscando"
                type="number"
              />
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="filtro.itemCliente.codigoItem"
                label="Código Interno"
                :loading="buscando"
              />
            </v-col>

            <v-col cols="auto" class="d-flex align-center">
              <v-btn class="ml-4" color="primary" outlined type="submit" :loading="buscando">
                <v-icon left> mdi-magnify </v-icon>
                Pesquisar
              </v-btn>
              <v-btn
                class="ml-4"
                color="normal"
                outlined
                type="submit"
                :loading="buscando"
                @click.stop.prevent="limparSelecaoDeFiltros"
              >
                <v-icon left> mdi-autorenew </v-icon>
                Limpar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
    <v-card class="mt-4">
      <v-container fluid>
        <v-data-table
          :items="pagina.content"
          :headers="headers"
          :loading="buscando"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 30, 50] }"
          :server-items-length="pagina.totalElements"
          :options.sync="options"
        >
          <template #[`item.actions`]="{ item }">
            <v-row>
              <v-col>
                <v-tooltip top>
                  <template #activator="{ on }">
                    <v-icon
                      dark
                      color="primary"
                      v-on="on"
                      @click="() => abrirDialogTributacao(item)"
                    >
                      mdi-clipboard-text-outline
                    </v-icon>
                  </template>
                  <span>Ver Tributação</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-container>
    </v-card>

    <v-dialog
      v-model="vizualizarDialogTributacao"
      fullscreen
      transition="dialog-bottom-transition"
      max-width="1200px"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="fecharDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <v-row>
              <v-col>
                {{ itemSelecionado.itemCliente.descricaoItem }} -
                {{ itemSelecionado.itemCliente.codigoBarra }}
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-toolbar>
        <v-container class="grey lighten-5" fluid>
          <v-row>
            <v-col>
              <v-row no-gutters>
                <v-col md="12" class="ml-1">
                  <h2>NCM</h2>
                </v-col>
              </v-row>
              <v-row v-for="(item, i) in detalhesNcm" :key="i" no-gutters>
                <v-col md="2">
                  <v-card class="pa-1" outlined v-text="item.codigo ? item.codigo : '-'" />
                </v-col>
                <v-col md="10">
                  <v-card class="pa-1" outlined v-text="item.descricao" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row v-if="itemSelecionado.itemVo.cest">
            <v-col>
              <v-row no-gutters>
                <v-col md="12" class="ml-1">
                  <h2>CEST</h2>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col md="2">
                  <v-card class="pa-1" outlined>
                    {{ itemSelecionado.itemVo.cest ? itemSelecionado.itemVo.cest.codigo : '' }}
                  </v-card>
                </v-col>
                <v-col md="10">
                  <v-card class="pa-1" outlined>
                    {{ itemSelecionado.itemVo.cest ? itemSelecionado.itemVo.cest.descricao : '-' }}
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="8">
              <v-row no-gutters>
                <v-col md="12" class="ml-1">
                  <h2>ICMS Entrada</h2>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col md="12">
                  <v-card outlined>
                    <v-data-table
                      :items="ICMSsEntrada"
                      :headers="headersICMSsEntrada"
                      :sort-by="['icms.uf.sigla', 'dataFimVigencia']"
                      hide-default-footer
                      dense
                    >
                      <template #[`item.origemDestino`]="{ item }">
                        {{
                          `${item.ufOrigem ? item.ufOrigem.sigla : ''} -
                          ${item.ufDestino ? item.ufDestino.sigla : ''}`
                        }}
                      </template>

                      <template #[`item.dataInicioVigencia`]="{ item }">
                        {{ formatDate(item.dataInicioVigencia) }}
                      </template>

                      <template #[`item.dataFimVigencia`]="{ item }">
                        {{ formatDate(item.dataFimVigencia) }}
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>

            <v-col md="4">
              <v-row no-gutters>
                <v-col md="12" class="ml-1">
                  <h2>ICMS Saída</h2>
                </v-col>
              </v-row>

              <v-row v-for="(item, i) in tabelaIcmsSaida" :key="i" no-gutters>
                <v-col md="8">
                  <v-card class="pa-1" outlined v-text="item.chave ? item.chave : '-'" />
                </v-col>

                <v-col md="4">
                  <v-card class="pa-1" outlined v-text="item.valor" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <b>Legislação ICMS</b>
              <li>{{ itemVoIcms.icms.descricao }}</li>
              <li>
                {{ `Início: ${formatDate(itemVoIcms.dataInicioVigencia)} ` }}
              </li>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="4">
              <v-row no-gutters>
                <v-col md="12" class="ml-1">
                  <h2>PIS COFINS Entrada</h2>
                </v-col>
              </v-row>
              <v-row v-for="(item, i) in tabelaPisCofinsEntrada" :key="i" no-gutters>
                <v-col md="8">
                  <v-card class="pa-1" outlined v-text="item.chave ? item.chave : '-'" />
                </v-col>
                <v-col md="4">
                  <v-card class="pa-1" outlined v-text="item.valor" />
                </v-col>
              </v-row>
            </v-col>
            <v-col md="4">
              <v-row no-gutters>
                <v-col md="12" class="ml-1">
                  <h2>PIS COFINS Saída</h2>
                </v-col>
              </v-row>
              <v-row v-for="(item, i) in tabelaPisCofinsSaida" :key="i" no-gutters>
                <v-col md="8">
                  <v-card class="pa-1" outlined v-text="item.chave ? item.chave : '-'" />
                </v-col>
                <v-col md="4">
                  <v-card class="pa-1" outlined v-text="item.valor" />
                </v-col>
              </v-row>
            </v-col>
            <v-col md="4">
              <v-row no-gutters>
                <v-col md="12" class="ml-1">
                  <h2>IPI</h2>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col md="12">
                  <v-row no-gutters>
                    <v-col md="8">
                      <v-card class="pa-1" outlined>CST</v-card>
                    </v-col>
                    <v-col md="4">
                      <v-card class="pa-1" outlined>
                        {{ itemSelecionado.itemVo.ipi.cst }}
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col md="8">
                      <v-card class="pa-1" outlined>% IPI</v-card>
                    </v-col>
                    <v-col md="4">
                      <v-card class="pa-1" outlined>
                        {{ itemSelecionado.itemVo.ipi.aliquota }}
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col md="12">
                      <v-card class="pa-1" outlined>
                        {{ itemSelecionado.itemVo.ipi.descricao }}
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <b>Legislação Pis Cofins</b>
              <li>{{ pisCofinsItem.descricao }}</li>
              <li>{{ pisCofinsItem.lei.nome }}</li>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />
  </v-container>
</template>

<script>
import SnackBar from '@/models/components/snackbar'
import SnackbarMessage from '@/components/SnackbarMessage'
import ItemClienteService from '@/services/atualizacao/itemCliente'
import NCMService from '@/services/ncm/ncm'
import ItensVOService from '@/services/itensVO/itensVO'
import ICMSService from '@/services/icms/icms'
import PISCOFINSService from '@/services/pisCofins/pisCofins'
import { formatDate, formataCpfCnpj } from '@/shareds/formatacoes'
export default {
  components: {
    SnackbarMessage
  },
  data: () => ({
    name: 'TelaDeTributacao',
    headers: [
      { text: 'Código Interno', value: 'itemCliente.codigoItem', divider: true },
      { text: 'Código Barras', value: 'itemCliente.codigoBarra', divider: true },
      { text: 'Descrição', value: 'itemCliente.descricaoItem', divider: true },
      { text: 'NCM', value: 'itemCliente.ncm.codigo', divider: true },
      { text: 'NESH', value: 'itemVo.nesh.descricao', divider: true },
      { text: 'CEST', value: 'itemVo.cest.codigo', divider: true },
      { text: '', value: 'actions', sortable: false }
    ],
    itensClienteVo: [],
    filtro: {
      itemCliente: {
        codigoItem: null,
        codigoBarra: null,
        descricao: null,
        ncm: null
      }
    },
    buscando: false,
    snackbar: new SnackBar(),
    showDialogEdicaoParam: false,
    showDialogCriacaoParam: false,
    vizualizarDialogTributacao: false,
    /*Informações tributacao por item*/
    itemSelecionado: {
      itemCliente: {
        descricaoItem: '',
        codigoBarra: '',
        ncm: {
          codigo: '',
          descricao: ''
        },
        cest: {
          codigo: '',
          descricao: ''
        }
      },
      itemVo: {
        ipi: {
          descricao: '',
          aliquota: 0,
          cst: {
            codigo: ''
          }
        }
      }
    },
    detalhesNcm: [],
    tabelaIcmsSaida: [],
    tabelaPisCofinsSaida: [],
    tabelaPisCofinsEntrada: [],
    headersICMSsEntrada: [
      { text: 'Tipo Fornecedor', value: 'tipoFornecedor', divider: true, sortable: false },
      { text: 'Origem Destino', value: 'origemDestino', divider: true, sortable: false },
      { text: 'CST Entrada', value: 'escritaFiscalCst', divider: true, sortable: false },
      {
        text: '% ICMS Crédito Livro Entrada',
        value: 'escritaFiscalPercentualIcms',
        divider: true,
        sortable: false
      },
      {
        text: '% ICMS Original para Cálculo ST',
        value: 'notaFiscalPercentualIcms',
        divider: true,
        sortable: false
      },
      { text: '% Redução', value: 'escritaFiscalReducao', divider: true, sortable: false },
      { text: 'Vedação Crédito NCM', value: 'codigoNcm', divider: true, sortable: false }
    ],
    ICMSsEntrada: [],
    formatDate: formatDate,
    pisCofinsItem: {
      descricao: '',
      lei: {
        nome: ''
      }
    },
    itemVoIcms: {
      icms: {},
      dataInicioVigencia: ''
    },
    options: {},
    pagina: {}
  }),

  computed: {},

  watch: {
    vizualizarDialogTributacao(val) {
      val || this.fecharDialog()
    },
    options(options) {
      this.pagina.size = options.itemsPerPage
      this.pagina.page = options.page - 1
      this.buscarItensVinculadosComFiltro(false)
    }
  },

  methods: {
    async buscarItensVinculadosComFiltro(zerar) {
      this.buscando = true

      if (zerar) {
        this.pagina.page = 0
        this.options.page = 1
      }

      await ItemClienteService.getAllItensVinculados({
        descricaoItemCliente: this.filtro.itemCliente.descricao || undefined,
        ncmItemCliente: this.filtro.itemCliente.ncm || undefined,
        codigoItemCliente: this.filtro.itemCliente.codigoItem || undefined,
        codigoBarra: this.filtro.itemCliente.codigoBarra || undefined,
        page: this.pagina.page,
        size: this.pagina.size
      })
        .then((response) => {
          this.pagina = response
        })
        .catch((error) => {
          this.snackbar.snackTextParam = 'Ocorreu um erro ao buscar os itens. Erro: ' + error
          this.snackbar.snackTypeParam = 'error'
          this.snackbar.showSnackParam = true
        })

      this.buscando = false
    },

    limparSelecaoDeFiltros() {
      this.filtro = {
        itemCliente: {
          codigoItem: null,
          codigoBarra: null,
          descricao: null,
          ncm: null
        }
      }
    },

    abrirDialogTributacao(item) {
      this.vizualizarDialogTributacao = true
      this.itemSelecionado = item
      this.buscarNcms(this.itemSelecionado.itemCliente.ncm.codigo)
      this.buscarIcms(this.itemSelecionado.itemVo.id)
      this.buscarPisCofins(this.itemSelecionado.itemVo.pisCofins.id)
    },

    async buscarNcms(codigo) {
      await NCMService.getEstruturaByCodigo(codigo)
        .then((response) => {
          this.detalhesNcm = response
        })
        .catch((error) => {
          this.snackbar.snackTextParam = 'Ocorreu um erro ao buscar os ncms. Erro: ' + error
          this.snackbar.snackTypeParam = 'error'
          this.snackbar.showSnackParam = true
        })
    },

    async buscarIcms(itemVoId) {
      this.itemVoIcms = await ItensVOService.buscarIcmsAtual(itemVoId)

      this.tabelaIcmsSaida.push({
        chave: 'CST',
        valor: this.itemVoIcms.icms.cst.codigo
      })

      this.tabelaIcmsSaida.push({
        chave: '% ICMS Original',
        valor: this.itemVoIcms.icms.icmsOriginal
      })

      this.tabelaIcmsSaida.push({
        chave: '% ICMS Livro Saída',
        valor: this.itemVoIcms.icms.icmsSaida
      })

      this.tabelaIcmsSaida.push({
        chave: '% MVA Original',
        valor: this.itemVoIcms.icms.mva
      })

      this.buscarValoresEntradaIcms(this.itemVoIcms.icms.id)
    },

    async buscarValoresEntradaIcms(icmsId) {
      const response = await ICMSService.buscarValoresEntradaIcms(icmsId)
      this.ICMSsEntrada = response.map((item) => ({
        ...item,
        cnpj: item.cnpj ? formataCpfCnpj(item.cnpj) : null
      }))
    },

    async buscarPisCofins(pisCofinsId) {
      this.pisCofinsItem = await PISCOFINSService.getById(pisCofinsId)
      this.tabelaPisCofinsEntrada = []
      this.tabelaPisCofinsSaida = []

      this.tabelaPisCofinsEntrada.push({
        chave: 'CST',
        valor: this.pisCofinsItem.cstEntrada.codigo
      })
      this.tabelaPisCofinsEntrada.push({
        chave: '% PIS',
        valor: this.pisCofinsItem.percentualPISEntrada
      })
      this.tabelaPisCofinsEntrada.push({
        chave: '% COFINS',
        valor: this.pisCofinsItem.percentualCOFINSEntrada
      })
      this.tabelaPisCofinsEntrada.push({
        chave: 'Natureza Receita',
        valor: this.pisCofinsItem.naturezaEntrada?.codigo
      })

      this.tabelaPisCofinsSaida.push({
        chave: 'CST',
        valor: this.pisCofinsItem.cstSaida.codigo
      })
      this.tabelaPisCofinsSaida.push({
        chave: '% PIS',
        valor: this.pisCofinsItem.percentualPISSaida
      })
      this.tabelaPisCofinsSaida.push({
        chave: '% COFINS',
        valor: this.pisCofinsItem.percentualCOFINSSaida
      })
      this.tabelaPisCofinsSaida.push({
        chave: 'Natureza Receita',
        valor: this.pisCofinsItem.naturezaSaida?.codigo
      })
    },

    fecharDialog() {
      this.tabelaIcmsSaida = []
      this.vizualizarDialogTributacao = false
    }
  }
}
</script>

<style>
.theme--light.v-data-table tr {
  height: 70px;
}
</style>
